var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPinA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#ca4539;}.c{opacity:0;}.d{fill:#707070;}.e{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 3,
    y: 0,
    width: 26,
    height: 36,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#002445",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-145 -5244)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(152.824 5248.283)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, -7.82, -4.28)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.452,24.184h9.1A53.465,53.465,0,0,1,10,30,53.531,53.531,0,0,1,5.452,24.184Zm0,0C2.811,20.291,0,15.024,0,10.17A10.086,10.086,0,0,1,10,0,10.087,10.087,0,0,1,20,10.17c0,4.854-2.81,10.121-5.452,14.014Z",
    transform: "translate(6 3)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.111,22.673h8.527a50.123,50.123,0,0,1-4.264,5.452A50.185,50.185,0,0,1,5.111,22.673Zm0,0C2.636,19.023,0,14.085,0,9.534A9.456,9.456,0,0,1,9.375,0,9.457,9.457,0,0,1,18.75,9.534c0,4.55-2.634,9.488-5.111,13.138Z",
    transform: "translate(-1.199 -0.658)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3.176 3.717)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32,
    transform: "translate(177 5278) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1,1V31H31V1H1M0,0H32V32H0Z",
    transform: "translate(177 5278) rotate(180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinA);
export default __webpack_public_path__ + "static/media/icon_pin_a.7e10bed798fd30f95e5ef71f6e3b489b.svg";
export { ForwardRef as ReactComponent };